import React, { useMemo } from "react";
import moment from "moment";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from "@material-ui/core";

import ExpandMoreIcon from "../../assets/svg/ExpandAccordionIcon.svg";
import { HH_MM } from "../../../config/constants";
import { get_class_name_based_on_status } from "../utils/ApprovalRequestRecordUtils";
import {
  getDayFromSlot,
  isArrayValid,
  isAString,
  isEmptyOrNull,
} from "../../../utils/DataUtils";
import { DATA_IDENTIFIER, ELEMENT } from "components/common/App/app-constant";
import { generateElementIdentifier } from "utils/ApplicationUtils";

interface ApprovalRequestSlotDetailsForExpressInterface {
  classes: any;
  slot_day_data: any;
  slot_data_object?: any;
  slot_data_object_key: any;
}

const ApprovalRequestSlotDetailsForExpress = (
  props: ApprovalRequestSlotDetailsForExpressInterface
) => {
  const { classes, slot_day_data, slot_data_object, slot_data_object_key } =
    props;

  const slotDay = useMemo(() => getDayFromSlot(slot_day_data), [slot_day_data]);

  const renderSlotDataContent = () => {
    let slotsToRender;

    if (
      !isEmptyOrNull(slot_day_data) &&
      !isEmptyOrNull(slot_data_object) &&
      isArrayValid(slot_data_object?.[slot_day_data])
    ) {
      slotsToRender = slot_data_object[slot_day_data];
    } else if (isArrayValid(slot_day_data?.generatedSlots)) {
      slotsToRender = slot_day_data.generatedSlots;
    }

    if (isArrayValid(slotsToRender)) {
      return slotsToRender.map((slot: any, slot_index: any) =>
        get_slot_details_view(slot, slot_index)
      );
    }
    return null;
  };

  

  const get_slot_details_view = (slot: any, slot_index: any) => {
    return (
      <Grid
        container
        spacing={1}
        key={`${slot_index}-slot_day_data-slot_index-slot_data_object`}
        className={get_class_name_based_on_status(
          slot,
          classes,
          slot_data_object_key
        )}
      >
        <Grid
          data-testid={generateElementIdentifier({
            key: DATA_IDENTIFIER.TIME,
            customKey: slot.id,
            element: ELEMENT.GRID,
          })}
          item
          xs={5}
          className={classes.slotDetailsValueSpanStyle}
        >{moment(slot.startTime).format(HH_MM)}</Grid>
        <Grid
          data-testid={generateElementIdentifier({
            key: DATA_IDENTIFIER.ORDER_CUT_OFF,
            customKey: slot.id,
            element: ELEMENT.GRID,
          })}
          item
          xs={5}
          className={classes.slotDetailsValueSpanStyle}
        >{`${moment(slot.endTime).format(HH_MM)}`}</Grid>
        <Grid
          data-testid={generateElementIdentifier({
            key: DATA_IDENTIFIER.CAPACITY,
            customKey: slot.id,
            element: ELEMENT.GRID,
          })}
          item
          xs={2}
          className={classes.slotDetailsValueSpanStyle}
        >{`${slot.slotCapacity}`}</Grid>
      </Grid>
    );
  };

  return (
    <Accordion className={classes.slotsAccordion} defaultExpanded>
      <AccordionSummary
        expandIcon={<img src={ExpandMoreIcon} alt="Expand Accordion Icon" />}
        className={classes.slotsAccordionSummary}
      >
        <Typography className={classes.approverDetailsHeadingSpanStyle}>
          {slotDay}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.dBlock}>
        <Grid container spacing={1}>
          <Grid
            item
            xs={5}
            className={classes.approverDetailsHeadingSpanStyle}
          >{`First Customer Order Time`}</Grid>
          <Grid
            item
            xs={5}
            className={classes.approverDetailsHeadingSpanStyle}
          >{`Last Order Cut-off Time`}</Grid>
          <Grid
            item
            xs={2}
            className={classes.approverDetailsHeadingSpanStyle}
          >{`Capacity`}</Grid>
        </Grid>
        {renderSlotDataContent()}
      </AccordionDetails>
    </Accordion>
  );
};

export default React.memo(ApprovalRequestSlotDetailsForExpress);
